module.exports = __webpack_public_path__ + "media/images/illustrations/phone_inventory-51abf894aa51b1c9e406f60520fcd269.svg";